export const GET_ALLEGATI = `
query findAllegati($where: AllegatiWhereInput, $first: Int!, $skip: Int) {
  allegatis(
    first: $first
    skip: $skip
    where: $where
    order:createdAt_DESC
  ) {
    count
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        objectId
        createdAt
        updatedAt
        allegato {
          url
          name
        }
        defunto_pointer {
          objectId
        }
        isImageEnhancement
        isSmile
        isBlurBg
        isRemovebg
        isColorizeBw
        isAutoColor
        isMagicEraser
        isChangeClothes
        isExpand
        smileRawImage
        removebgRawImage
        colorizeBwRawImage
        enhancementRawImage
        magicEraserRawImage
        changeClothesRawImage
        expandRawImage
        isBackgroundFusion
        backgroundFusionRawBackground
        backgroundFusionRawSubject
        backgroundFusionComposite
        magicEraserMask
        changeClothesMask
        condiviso
        rawImage
        isAiEdit
        aiEditRawImage
        aiEditPrompt
        org_pointer {
          objectId
          nome
        }
      }
    }
  }
}  
`;
